
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 5.18h4.18l-3.36-3.36h-.82v3.36zm1.172 5.039c.26.234.56.351.898.351.339 0 .625-.117.86-.351.26-.26.39-.56.39-.899 0-.338-.13-.625-.39-.86-.235-.26-.521-.39-.86-.39-.338 0-.638.13-.898.39-.235.235-.352.522-.352.86 0 .339.117.638.352.899zm-2.852-5.04V1.82H7.5v3.36h3.32zm-6.718 5.04c.234.234.533.351.898.351s.664-.117.898-.351c.235-.26.352-.56.352-.899 0-.338-.117-.625-.352-.86A1.155 1.155 0 005 8.07c-.365 0-.664.13-.898.39-.235.235-.352.522-.352.86 0 .339.117.638.352.899zM2.5 5.179h3.32V1.82H2.5v3.36zm11.68-5l5 5V9.32h-2.11c0 .677-.247 1.263-.742 1.758-.495.495-1.08.742-1.758.742-.677 0-1.263-.247-1.758-.742-.494-.495-.742-1.08-.742-1.758H7.5c0 .677-.247 1.263-.742 1.758-.495.495-1.08.742-1.758.742-.677 0-1.263-.247-1.758-.742-.495-.495-.742-1.08-.742-1.758H.82v-7.5c0-.468.157-.86.47-1.172A1.724 1.724 0 012.5.18h11.68z","fill":"currentColor"}})])
          )
        }
      }
    